import { Stack } from '@workramp/ui';
import StringUtils from '~/common/string-utils';
import { ColorPickerSetting, ColorPickerWithDefaultSetting } from '../../ThemingEditorPage';

interface ColorSettingsProps {
  colorOptions: Record<string, string | Record<string, any>>;
  isLockable?: boolean;
  onChange: (propName: string, v: string) => void;
  onLockChange?: (propName: string, propVal: { isLocked: boolean; value?: string }) => void;
}

export const ColorSettings = ({ colorOptions, onChange, isLockable = false, onLockChange }: ColorSettingsProps) => {
  const getSettingLabel = (key: string) => {
    if (key === 'buttonLinks') {
      return 'Button Background & Links';
    }

    return StringUtils.getCapitalizedWordsFromCamelCasedString(key);
  };

  return (
    <Stack size={6}>
      {Object.entries(colorOptions).map(([key, settings]) =>
        isLockable ? (
          <ColorPickerWithDefaultSetting
            key={key}
            label={getSettingLabel(key)}
            allowAlpha
            value={typeof settings === 'object' ? settings.value : settings}
            isLocked={typeof settings === 'object' ? settings.isLocked : false}
            onLockPress={() => {
              if (typeof settings !== 'object') return console.error('This property is not lockable');

              const newSettings: { isLocked: boolean; value?: string } = {
                isLocked: !settings.isLocked,
              };

              // if the user is unlocking the color, set it to the override value
              if (settings.isLocked) {
                newSettings.value = settings.value;
              }

              return onLockChange(key, newSettings);
            }}
            onChange={(v: string) => onChange(key, v)}
          />
        ) : (
          <ColorPickerSetting
            key={key}
            allowAlpha
            label={getSettingLabel(key)}
            value={typeof settings === 'object' ? settings.value : settings}
            onChange={(v: string) => onChange(key, v)}
          />
        ),
      )}
    </Stack>
  );
};
